import React from 'react';
import { Icon } from 'b3';
import { Link } from 'react-router';
import moment from 'moment';
import ClientStageWithIcon from '../../clients/ClientStageWithIcon';
import ClockForTimezone from '../../ClockForTimezone';

export default function UnCompletedActivityHeader({
	client, 
	score, 
	numberOfStaff, 
	scheduleName, 
	tags, 
	avatar, 
	assignedUser, 
	isMeeting = false,
	location = null,
	date
}) {
	var { timezone } = client;
	const formattedDate = date ? moment(date).format("ddd MMM Do h:mm A") : date;

	return (
		<div className="unCompletedActivityHeader">
			<div className={`unCompletedActivityHeader__withCompanyAndStaff ${isMeeting ? 'meeting' : 'phonecall'}`}>
				<strong>
					{scheduleName}
					<Link to={`/clients/${client.id}`}>{client.name}</Link>
					for
					{avatar}
					{assignedUser &&				
						<Link to={`/teams/user/${assignedUser.id}`}>{`${assignedUser.firstName} ${assignedUser.lastName}`}</Link>
					}
				</strong>
				{location &&
					<span>( {location.capitalise()} )</span>
				}
				
				<div className="unCompletedActivityHeader__withCompanyAndStaff__tags">
					{tags.map(tag =>
					    <span key={tag.id}>{tag.name}</span>
					)}
				</div>
			</div>

			<div className="unCompletedActivityHeader__quickClientOverview">
				<div className="unCompletedActivityHeader__quickClientOverview__item">
					<Icon icon="clock-1" /> Booking Time:&nbsp; {formattedDate}
				</div>
			</div>

			<div className="unCompletedActivityHeader__quickClientOverview">
				<div className="unCompletedActivityHeader__quickClientOverview__item">
					<Icon icon="connection-2" /> <span>{numberOfStaff}</span>
				</div>
				<div className="unCompletedActivityHeader__quickClientOverview__item">
					<Icon icon="globe-1" /> 
					{timezone &&
						<ClockForTimezone timezone={timezone} format={"ddd MMM Do h:mm A"} />
					}
					{!timezone &&
						<span>n/a</span>
					}

					<span style={{marginLeft: 10}}>{`${client.addressCity}, ${client.country}`}</span>
				</div>
				<div className="unCompletedActivityHeader__quickClientOverview__item">
					<Icon icon="trophy" /> <span>{score == null ? 0 : score}</span>
				</div>
				<div className="unCompletedActivityHeader__quickClientOverview__stage">
					<ClientStageWithIcon clientStageId={client.clientStageId} />
				</div>
			</div>

		</div>
	)
}




// WEBPACK FOOTER //
// ./app/components/client-timeline/items/UnCompletedActivityHeader.js